// import Vue from 'vue'

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
// import 'firebase/app';
import 'firebase/functions'

const firebaseConfig = {
    apiKey: "AIzaSyDe3V-0WOmQeANxS9j3_MhVWpY6GwokV_Y",
    authDomain: "kilbi-songgl.firebaseapp.com",
    databaseURL: "https://kilbi-songgl.firebaseio.com",
    projectId: "kilbi-songgl",
    storageBucket: "kilbi-songgl.appspot.com",
    messagingSenderId: "226697561649",
    appId: "1:226697561649:web:3fad2500e983ba5a2eb710",
};
firebase.initializeApp(firebaseConfig);

if(window.location.hostname === 'localhost') {
    firebase.app().functions('europe-west1').useEmulator('localhost', 5001);
    firebase.app().firestore().useEmulator('localhost', 5005);
    firebase.app().storage().useEmulator('localhost', 9199);
}

try
{
    // Vue.prototype.$analytics = firebase.analytics();
}
catch (e)
{
    alert('Cookies müssen eingeschalten sein, damit diese Seite ordnungsgemäß funktioniert');
    //alert(e.message);
}



// firebase utils
const fire = firebase;
const db = firebase.firestore()
const functions = firebase.functions()
const auth = firebase.auth()
let currentUser = auth.currentUser
const storage = firebase.storage()
let app = firebase.app()

// firebase collections
const ordersCollection = db.collection('orders')
const usersCollection = db.collection('customers')


export {
    fire,
    app,
    db,
    auth,
    storage,
    functions,
    currentUser,
    ordersCollection,
    usersCollection,
}
